module.exports = __webpack_public_path__ + "media/flags/zw-8941a670.svg";